import { render, staticRenderFns } from "./ScientificDegreesTable.vue?vue&type=template&id=00b27658&"
import script from "./ScientificDegreesTable.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports